import {FC, useEffect, useState} from 'react'
import {API_URL, toAbsoluteUrl} from '../../../_metronic/helpers'
import axios from 'axios'

const SamanIPGCallback: FC = () => {
  //MID=0&TerminalId=21536624&RefNum=GmshtyjwKSs%2bvuL1QwUfLUGY1bvPfWWe9JxdLINbHR&ResNum=AB813FA4CB4C7339F4DAB7E187461869&State=OK&TraceNo=997908&Amount=11000&Wage=&Rrn=22962731223&SecurePan=502229******6431&Token=759df70d5f5a466ab6cc61119632bfad&HashedCardNumber=62689193D6A1C449BAB454A1D9E3BE564CCE97720948C96B1F818BC59C9FA51F&Status=2&AffectiveAmount=11000
  const searchParams = new URLSearchParams(document.location.search)

  const [MID, setMID] = useState(searchParams.get('MID') || '')
  const [TerminalId, setTerminalId] = useState(searchParams.get('TerminalId') || '')
  const [RefNum, setRefNum] = useState(searchParams.get('RefNum') || '')
  const [ResNum, setResNum] = useState(searchParams.get('ResNum') || '')
  const [State, setState] = useState(searchParams.get('State') || '')
  const [TraceNo, setTraceNo] = useState(searchParams.get('TraceNo') || '')
  const [Amount, setAmount] = useState(searchParams.get('Amount') || '')
  const [Wage, setWage] = useState(searchParams.get('Wage') || '')
  const [Rrn, setRrn] = useState(searchParams.get('Rrn') || '')
  const [SecurePan, setSecurePan] = useState(searchParams.get('SecurePan') || '')
  const [Token, setToken] = useState(searchParams.get('Token') || '')
  const [HashedCardNumber, setHashedCardNumber] = useState(
    searchParams.get('HashedCardNumber') || ''
  )
  const [Status, setStatus] = useState(searchParams.get('Status') || '')
  const [AffectiveAmount, setAffectiveAmount] = useState(searchParams.get('AffectiveAmount') || '')

  const [send, setSend] = useState(false)
  const [result, setResult] = useState<any>()

  useEffect(() => {
    if (!send) {
      check()
    }
  }, [])

  const check = async () => {
    axios
      .post(`${API_URL}/payment/cb/sepipg`, {
        MID: MID,
        TerminalId: TerminalId,
        RefNum: RefNum,
        ResNum: ResNum,
        State: State,
        TraceNo: TraceNo,
        Amount: Amount,
        Wage: Wage,
        Rrn: Rrn,
        SecurePan: SecurePan,
        Token: Token,
        HashedCardNumber: HashedCardNumber,
        Status: Status,
        AffectiveAmount: AffectiveAmount,
      })
      .then((response) => {
        setSend(true)
        setResult(response.data)
        setTimeout(() => {
          window.location.replace('https://my.asatsp.ir/invoicePrint/' + response.data.hash)
        }, 1000)
      })
  }

  return (
    <>
      {!send && (
        <p className='w-100 text-center fs-2x p-10'>
          <i className='las la-spinner fs-3x me-5 la-spin text-success'></i>
          در حال بررسی تراکنش
        </p>
      )}
      {send && result && <p className='w-100 text-center fs-2x p-10'>{result.ResultDescription}</p>}
    </>
  )
}

export {SamanIPGCallback}
